

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/esm/Container';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
export function Contact() {
  return (
    <Container className='contact-section' id="contact">
      <h2 className='text-white m-4'>Contact Me</h2>

      <Card className='shadow' bg={"dark"} text='white' >

        <Card.Body>
          <Form action="https://mailthis.to/leon-resume-email" method="POST">
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" name="name" required placeholder="Enter name" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Email address</Form.Label>
              <Form.Control name="_replyto" type="email" required placeholder="Enter email" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" name="message" rows={3} placeholder="Enter your message" required />
            </Form.Group>
            <input type="hidden" name="_subject" value="Contact form submitted" />
            <input type="hidden" name="_honeypot" value="" />
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Card.Body>
      </Card>

    </Container>
  );
}

